export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Resize + re-encode a photo in the browser so a compact JPEG is uploaded.
export function compressImage(file, maxSide = 2000, quality = 0.88) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error(`Cannot open ${file.name}. Use a JPG or PNG photo.`)); };
    img.src = url;
  });
}

// "3+4.5" -> 7.5 ; anything else -> null
export function sumExpr(text) {
  const t = (text || "").replace(/\s/g, "");
  if (!/^\d+(\.\d+)?(\+\d+(\.\d+)?)*$/.test(t)) return null;
  return Math.round(t.split("+").reduce((a, p) => a + Number(p), 0) * 1000) / 1000;
}

// Keep the focused field visible above the on-screen keyboard (iPad / iPhone).
export const keepVisible = (e) => { const el = e.target; setTimeout(() => el.scrollIntoView({ block: "center", behavior: "smooth" }), 300); };

export const slugify = (s) => String(s).replace(/[^a-z0-9]+/gi, "-").toLowerCase();

export const STATUS = {
  matched: { label: "Matched", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  mismatch: { label: "Quantity Mismatch", cls: "bg-red-100 text-red-800 border-red-200" },
  missing_on_website: { label: "Missing on Website", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  missing_in_book: { label: "Not Found in Notebook", cls: "bg-purple-100 text-purple-800 border-purple-200" },
  needs_check: { label: "Needs Manual Check", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  deleted: { label: "Deleted from Website", cls: "bg-slate-100 text-slate-700 border-slate-300" },
};

export const DECISION = {
  update_sale: "Corrected on website",
  create_sale: "Sale created on website",
  delete_sale: "Website sale deleted",
  accept_website: "Website kept (book was wrong)",
  confirm_valid: "Confirmed sale is valid",
  dismiss: "Not created (book was wrong)",
};

export const FIELD = "h-11 text-base md:text-base";
